import { put, takeLatest, all, call, select } from 'redux-saga/effects'

import { environment } from 'config/environment'
import { strings } from 'context/LanguageContext/strings'
// import { clearBraintreeClientToken } from 'modules/authentication/actions'
import { getSubscriptionPaymentMethods } from 'modules/subscription/sagas'
import {
    actions,
    addCardSuccess,
    addCardFailed,
    getSavedCardsSuccess,
    getSavedCardsFailed,
    removeCardSuccess,
    removeCardFailed,
    selectCard,
    defaultCard,
    addPaypalPaymentSuccess,
    addPaypalPaymentFailed,
    saveSelectedPaymentMethodSuccess,
    saveSelectedPaymentMethodFailed,
    setCardLinkedToSubscription,
} from 'modules/wallet/actions'
import {
    addPaymentMethodURL,
    getCardsURL,
    removeCardURL,
    saveDefaultCardsURL,
} from 'modules/wallet/urls'
import { api } from 'network/api'
import { getCurrentCountry, isEmpty } from 'utils/appUtils'
import constants from 'utils/constants'
import { payment } from 'utils/paymentUtils'

export function* getSavedCards(action) {
    try {
        const { user } = yield select()
        const profile = user.get('userProfile')
        const training_mode = (profile && profile.get('training_mode')) || false
        const timeStamp = new Date().getTime()
        const cards = yield call(
            api,
            `${getCardsURL}/?live=${!training_mode}&timeStamp=${timeStamp}`,
            'GET'
        )
        yield* setDefaultCard(cards.payment_methods)
        yield put(getSavedCardsSuccess(cards.payment_methods))
        if (cards?.subscription_payment_methods) {
            yield put(setCardLinkedToSubscription(cards.subscription_payment_methods))
        }

        if (action?.payload) {
            const paypalToAdd = cards?.payment_methods?.filter(
                item => item.token === action.payload
            )[0]
            yield put(selectCard(paypalToAdd))
        }
    } catch (error) {
        yield put(getSavedCardsFailed(error))
    }
}

export function* saveSelectedPaymentMethod(action) {
    try {
        if (action.payload) {
            const { id, customer } = action.payload
            const payload = {
                cardId: id,
                stripeCustId: customer,
                training_mode: false,
            }
            yield call(api, saveDefaultCardsURL, 'POST', payload, 1)
            yield put(saveSelectedPaymentMethodSuccess())
        }
    } catch (error) {
        yield put(saveSelectedPaymentMethodFailed(error))
    }
}

export function* setDefaultCard(cards) {
    const { wallet } = yield select()
    const defaultCard = wallet.toJS().defaultCard || null
    if (defaultCard) {
        if (defaultCard.gateway === 'braintree') {
            if (cards && cards.length > 0) {
                let cardFound = false
                for (let i = 0; i < cards.length; i++) {
                    if (cards[i].token === defaultCard.token) {
                        cardFound = true
                        break
                    }
                }
            } else {
                yield put(selectCard(null))
            }
        } else {
            if (cards && cards.length > 0) {
                let cardFound = false
                for (let i = 0; i < cards.length; i++) {
                    if (cards[i].id === defaultCard.id) {
                        cardFound = true
                        break
                    }
                }
            } else {
                yield put(selectCard(null))
            }
        }
    } else {
        if (cards && cards.length > 0) {
            // let paypal = null
            // let venmo = null
            // cards.forEach(item => {
            //     if (!paypal && item.gateway === 'braintree') {
            //         if (item.brand === 'paypal') {
            //             paypal = item
            //         }
            //         if (item.brand === 'venmo') {
            //             venmo = item
            //         }
            //     }
            // })
            // if (paypal) {
            //     yield put(selectCard(paypal))
            // } else if (venmo) {
            //     yield put(selectCard(venmo))
            // } else {
            yield put(selectCard(cards[0]))
            // }
        } else {
            yield put(selectCard(null))
        }
    }
}

export function* addCard(action) {
    try {
        const { user } = yield select()
        const profile = user.get('userProfile')
        const training_mode = (profile && profile.get('training_mode')) || false
        const live = environment === 'production' && !training_mode
        const { token } = action.payload
        const subscriptions = action.payload.subscriptions || false
        const { card } = token

        const request = {
            last4: card.last4,
            exp_month: card.exp_month,
            exp_year: card.exp_year,
            brand: card.brand,
            source: token.id,
            address_zip: action.payload.zip,
            live,
            subscriptions,
            saveCard: true,
            isGuest: false,
            payment_mode: 'card',
        }
        const timeStamp = new Date().getTime()

        const response = yield call(
            api,
            `${addPaymentMethodURL}?timeStamp=${timeStamp}`,
            'POST',
            request
        )
        if (response && response.payment_customer_id) {
            yield put(addCardSuccess())
            // WIP  we might not have to set the added card as selected
            yield* getSavedCards()
            yield* getSubscriptionPaymentMethods()
            const { wallet } = yield select()
            const addedCard = wallet.toJS().cards.filter(c => c.id === response.payment_id)
            yield put(selectCard(addedCard[0]))
        } else {
            yield put(addCardFailed(strings.genericPaymentMethodFailureDescription))
        }
    } catch (error) {
        if (
            error &&
            error.data &&
            error.data.details &&
            error.data.details.error &&
            error.data.details.description &&
            error.status
        ) {
            if (error.data.details.error.toLowerCase() === 'duplicate_card') {
                yield put(addCardFailed(error.data.details.description, error.status))
            }
            // if ((error.data.message).toLowerCase() === 'incorrect_zip') {
            //     yield put(addCardFailed(strings.genericPaymentMethodFailureDescription, error.status))
            // }
        } else if (
            error &&
            error.data &&
            error.data.details &&
            error.data.details.errorCode &&
            error.data.details.message
        ) {
            if (error.data.details.errorCode == 32) {
                yield put(addCardFailed(error.data.details.message, error.status))
            }
        } else {
            yield put(
                addCardFailed(strings.genericPaymentMethodFailureDescription, error && error.status)
            )
        }
    }
}

export function* deleteCard(action) {
    const card = action.payload
    const { wallet } = yield select()
    const currentDefault = wallet.toJS().defaultCard || null
    const timeStamp = new Date().getTime()
    try {
        if (card) {
            const request = {
                payment_mode: card.id ? 'card' : card.brand, // can be paypal, venmo or card
                id: card.id || card.token, // cardId for card or token for venmo and paypal
                customer: card.customer || card.customerId, // stripe_cust_id or payment_customer_id
            }
            const response = yield call(
                api,
                `${removeCardURL}?timeStamp=${timeStamp}`,
                'POST',
                request
            )

            if (response && response.status && response.status === 'success') {
                if (currentDefault && currentDefault.id === card.id) yield put(defaultCard(null))
                yield* getSavedCards()
                yield* getSubscriptionPaymentMethods()
                yield put(removeCardSuccess())
            } else yield put(removeCardFailed('Failed to delete card'))
        }
    } catch (error) {
        yield put(removeCardFailed('Failed to delete card', error && error.status))
    }
}

// export function* addPaypalPaymentMethod(action) {
//     try {
//         const braintreeResponse = action.payload
//         const { location, user, configuration, authentication } = yield select()
//         const { braintreeClientToken } = authentication.toJS()
//         const profile = user.get('userProfile')
//         if (!profile) {
//             return
//         }
//         const training_mode = (profile && profile.get('training_mode')) || false
//         if (braintreeClientToken && !isEmpty(braintreeResponse) && braintreeResponse.nonce) {
//             let currency = configuration.get('currency')
//             if (!currency) {
//                 const countryCode = getCurrentCountry(location, user)
//                 if (countryCode === countryCode.CA) {
//                     currency = 'cad'
//                 } else {
//                     currency = 'USD'
//                 }
//             }
//             const request = {
//                 live: environment === 'production' && !training_mode,
//                 payment_mode: constants.paypal,
//                 payment_method_nonce: braintreeResponse.nonce,
//             }
//             const response = yield call(api, addPaymentMethodURL, 'POST', request)
//             yield put(clearBraintreeClientToken())
//             if (response && response.payment_customer_id) {
//                 yield put(addPaypalPaymentSuccess(response.payment_id))
//             } else {
//                 yield put(addPaypalPaymentFailed('Failed to add PayPal payment'))
//             }
//         }
//     } catch (error) {
//         yield put(addPaypalPaymentFailed(error?.data?.message || 'Failed to add PayPal payment'))
//     }
// }

// <================================================================================>

function* addCardWatcher() {
    yield takeLatest(actions.ADD_CARD, addCard)
}

function* removeCardWatcher() {
    yield takeLatest(actions.REMOVE_CARD, deleteCard)
}

function* getSavedCardsWatcher() {
    yield takeLatest(actions.GET_SAVED_CARDS, getSavedCards)
    yield takeLatest(actions.ADD_PAYPAL_PAYMENT_METHOD_SUCCESS, getSavedCards)
}

// function* addPaypalWatcher() {
//     yield takeLatest(actions.ADD_PAYPAL_PAYMENT_METHOD, addPaypalPaymentMethod)
// }

function* savePaymentWatcher() {
    yield takeLatest(actions.DEFAULT_CARD, saveSelectedPaymentMethod)
}

export default function* walletSaga() {
    yield all([
        addCardWatcher(),
        removeCardWatcher(),
        getSavedCardsWatcher(),
        // addPaypalWatcher(),
        savePaymentWatcher(),
    ])
}
